import React from 'react'
import Address from '../Address'

const onChange = (_onChange) => ({
  address_post_code,
  address_first_line,
  address_second_line,
  address_third_line,
}) => {
  _onChange({
    gp_address_post_code: address_post_code,
    gp_address_first_line: address_first_line,
    gp_address_second_line: address_second_line,
    gp_address_third_line: address_third_line,
  })
}
export default (props) => {
  const {
    gp_address_post_code,
    gp_address_first_line,
    gp_address_second_line,
    gp_address_third_line,
    onChange: formOnChange,
    ...rest
  } = props

  return (
    <Address
      address_post_code={gp_address_post_code}
      address_first_line={gp_address_first_line}
      address_second_line={gp_address_second_line}
      address_third_line={gp_address_third_line}
      onChange={onChange(formOnChange)}
      {...rest}
    />
  )
}
